import React, { useState, useEffect, useRef } from 'react';
import style from './BloodPressureWrite.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import Modal from '../../../../../components/comm/Modal';
import CustomDatePicker from '../../../../../components/datepicker/CustomDatePicker';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import URL from "../../../../../constants/url";
import ToastPopup from '../../../../../components/comm/ToastPopup';
import { useNavigate } from "react-router-dom";

import dayjs from 'dayjs'; 
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

const BloodPressureWrite = () => {
    const navigate = useNavigate();

    const [recordDate, setRecordDate] = useState(''); 
    const [openRecordDate, setOpenRecordDate] = useState(false);
    const [recordTime, setRecordTime] = useState(''); 
    const [openRecordTime, setOpenRecordTime] = useState(false);
    const [time, setTime] = useState({ hour: "", minute: "" });
    const systolicInputRef = useRef(null);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [systolic, setSystolic] = useState('');
    const [diastolic, setDiastolic] = useState('');

    //전송중 체크
    const isSendingRef = useRef(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);  //모달창
    const [modalTimeOpen, setModalTimeOpen] = useState(false);  //모달창

    // focus ref 추가
    const focusDateInputRef = useRef(null);
    const focusTimeInputRef = useRef(null);

    const dayRef = useRef(null);
    const timeRef = useRef(null);

    const [dateInputFocused, setDateInputFocused] = useState(false);
    const [timeInputFocused, setTimeInputFocused] = useState(false);


    const handleDateConfirm = (date) => {
        const today = new Date();
        today.setHours(0,0,0,0);
        const picked = new Date(date);
        picked.setHours(0,0,0,0);

        if (picked > today) {
            setOpenRecordDate(false); // 선택 후 바텀시트 닫기
            setModalOpen(true);   // 미래 날짜 선택 시 모달 열기
            setDateInputFocused(true);
            setOpenRecordDate(false);
            return;
        }

        setRecordDate(picked);
        setOpenRecordDate(false); // 선택 후 바텀시트 닫기
        setDateInputFocused(false);  // 올바른 날짜 선택 시 클래스 제거

        setTimeout(() => {
            if (dayRef.current) {
                dayRef.current.focus({ preventScroll: true });
                dayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 200);
    };
    

    const closeModal = () => {
        setModalOpen(false);

        // 포커스 이동만 처리
        setTimeout(() => {
            focusDateInputRef.current?.focus({ preventScroll: true });
            focusDateInputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 200);

        setOpenRecordDate(true);
        setDateInputFocused(true);  //클래스 추가
    }

    const closeModalTime = () => {
        setModalTimeOpen(false);
        if (focusTimeInputRef.current) {
            focusTimeInputRef.current.focus();
        }
        setOpenRecordTime(true);
        setTimeInputFocused(true); //클래스 추가
    }



    //시간표현 설정     
    const handleConfirmTime = (value) => {
        
        const now = new Date();
        const selectedDateTime = new Date(recordDate || now); // 선택된 날짜가 없으면 오늘 기준

        const hour = parseInt(value.hour, 10);
        const minute = parseInt(value.minute, 10);
        selectedDateTime.setHours(hour, minute, 0, 0);

        if (selectedDateTime > now) {
            setOpenRecordTime(false);   // 미래 시간 선택 시 모달 열기

            setTimeout(() => {
                setModalTimeOpen(true);
            }, 350);

            return;
        }

        setTime(value);

        const period = hour < 12 ? '오전' : '오후';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        const formattedTime = `${period} ${hour12}:${minute.toString().padStart(2, '0')}`;

        setRecordTime(formattedTime);
        setOpenRecordTime(false);
        setTimeInputFocused(false);

        setTimeout(() => {
            if (timeRef.current) {
                timeRef.current.focus({ preventScroll: true });
                timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 200);
    };  

    useEffect(() => {
        // 페이지 진입 시 수축기 input에 포커스
        if (systolicInputRef.current) {

            setTimeout(() => {
                    systolicInputRef.current.focus();
                    // iOS에서 포커스 시 화면이 input 위치로 스크롤되도록
                    systolicInputRef.current.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'center' ,
                    });
            }, 300);
            
        }
        // 현재 시간 기준 기본값 설정
        const now = new Date();
        setRecordDate(now);  // 측정일자

        const hour = now.getHours();
        const minute = now.getMinutes();

        setTime({ hour: hour.toString().padStart(2, '0'), minute: minute.toString().padStart(2, '0') });

        const period = hour < 12 ? '오전' : '오후';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        const formattedTime = `${period} ${hour12}:${minute.toString().padStart(2, '0')}`;

        setRecordTime(formattedTime);  // 측정시간

    }, []);


    const handleComplete = async () => {
        if (!systolic) {
            setToastMessage('수축기 혈압을 입력해주세요.');
            setToast(true);
            return;
        }
        else if (systolic < 0) {
            setToastMessage('0 이상의 수치를 입력해주세요.');
            setToast(true);
            return;
        }

        if (!diastolic) {
            setToastMessage('이완기 혈압을 입력해주세요.');
            setToast(true);
            return;
        }
        else if (diastolic < 0) {
            setToastMessage('0 이상의 수치를 입력해주세요.');
            setToast(true);
            return;
        }

        if (!recordDate) {
            setToastMessage('날짜을 선택해주세요.');
            setToast(true);
            return;
        }

        if (!recordTime) {
            setToastMessage('시간을 선택해주세요.');
            setToast(true);
            return;
        }

        if (isSendingRef.current) return;
        isSendingRef.current = true;

        const convertTo24Hour = (timeStr) => {
            const [period, time] = timeStr.split(' ');
            let [hour, minute] = time.split(':').map(Number);
            if (period === '오후' && hour !== 12) hour += 12;
            if (period === '오전' && hour === 12) hour = 0;
            return `${hour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}`;
        };

        const recDe = dayjs(recordDate).format('YYYYMMDD'); // 예: 20250703
        const recTm = convertTo24Hour(recordTime) + "00"; // 예: 1430 -> 143000

        const getRsltCd = (systolic, diastolic) => { // 결과코드 임의 저장 (추후 기획에 따라 기준 및 코드명 변경 요망)
            if (systolic >= 140 || diastolic >= 90) {
                return "D"; // Danger
            } else if (systolic >= 130 || diastolic >= 80) {
                return "C"; // Caution
            } else if (systolic < 90 || diastolic < 60) {
                return"C"; // Caution for hypotension
            } else {
                return "N"; // Normal
            }
        }


        const url = "/homecare/brssr/saveBloodPressureRecordHistory"
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem('jToken');
        console.log("========> usrInfoId: ", loginUser.usrInfoId);
        
        const reqBody = {
            usrInfoId: loginUser.usrInfoId
            , recDe: recDe
            , recTm: recTm
            , brssrTop: Number(systolic)
            , brssrLwet: Number(diastolic)
            , rsltCd: getRsltCd(Number(systolic), Number(diastolic))
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                navigate(URL.BLOOD_PRESSURE_RECORD, { state: { showToast: true, toastMessage: '기록 완료!' } });
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("혈압 측정 기록 저장 중 오류: ", err);
        } finally {
            isSendingRef.current = false;
        }
        
    };



    return (
        <>

            <HeadSub title="혈압 기록하기"/>


            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['record-writebox']}>
                        <div className={style['date-record']}>
                            <p>측정 일자</p>
                            <div className='input-box' data-type='c' ref={dayRef} tabIndex={0}>
                                <input 
                                    type="button" 
                                    inputMode="none" 
                                    placeholder='25.02.07' 
                                    value={recordDate ? dayjs(recordDate).format('YY.MM.DD') : ''}
                                    onClick={() => setOpenRecordDate(true)}
                                    className={dateInputFocused ? 'focused' : ''}
                                    ref={focusDateInputRef}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className={style['time-record']}>
                        <p>측정 시간</p>
                            <div className='input-box' data-type='c' ref={timeRef} tabIndex={0}>
                                <input 
                                    type="button" 
                                    inputMode="none" 
                                    placeholder='오후 01:30'  
                                    value={recordTime}
                                    onClick={() => setOpenRecordTime(true)} 
                                    className={timeInputFocused ? 'focused' : ''}
                                    ref={focusTimeInputRef}
                                    readOnly
                                    />
                            </div>
                        </div>

                        <div >
                            <p>수축기</p>
                            <div className='input-box' data-type='c'>
                                <input 
                                    type="number" 
                                    placeholder='---' 
                                    ref={systolicInputRef}
                                    value={systolic}
                                    onChange={(e) => setSystolic(e.target.value)}    
                                    aria-label='수축기 값을 입력해주세요'
                                />
                                    
                                <span className='unit'>mmHg</span>
                             </div>
                        </div>
                        <div>
                            <p>이완기</p>
                            <div className='input-box' data-type='c'>
                                <input 
                                    type="number" 
                                    placeholder='---' 
                                    value={diastolic}
                                    onChange={(e) => setDiastolic(e.target.value)}
                                    aria-label='이완기 값을 입력해주세요'
                                    />
                                <span className='unit'>mmHg</span>
                             </div>
                        </div>


                        <BottomSheet
                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지
                            open={openRecordTime}
                            onDismiss={() => {
                                setOpenRecordTime(false);
                                setTimeInputFocused(false); // 취소 시 focused 클래스 제거
                                setTimeout(() => {
                                    if (timeRef.current) {
                                        timeRef.current.focus({ preventScroll: true });
                                        timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }, 200);
                            }}
                            snapPoints={({ minHeight }) => minHeight}
                            blocking={true}
                            >

                            <CustomTimePicker 
                                onConfirm={handleConfirmTime}
                                titleTxt="측정 시간 선택"
                                onClose={() => {
                                    setOpenRecordTime(false);
                                    setTimeInputFocused(false); // 취소 버튼 클릭 시 클래스 제거
                                    setTimeout(() => {
                                    if (timeRef.current) {
                                        timeRef.current.focus({ preventScroll: true });
                                        timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }, 200);
                                }}
                            />
                        </BottomSheet>

                        <BottomSheet
                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지
                            open={openRecordDate}
                            onDismiss={() => {
                                setOpenRecordDate(false);
                                setDateInputFocused(false);
                                setTimeout(() => {
                                    if (dayRef.current) {
                                        dayRef.current.focus({ preventScroll: true });
                                        dayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }, 200);
                            }}
                            snapPoints={({ minHeight }) => minHeight}
                            blocking={true}
                            >

                            <CustomDatePicker 
                                titleTxt="측정 일자 선택"
                                onClose={() => {
                                    setOpenRecordDate(false);
                                    setDateInputFocused(false);
                                }}
                                //onConfirm={(date) => setRecordDate(date)}
                                onConfirm={handleDateConfirm}
                            />
                        </BottomSheet>

                    </div>




                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                            <div className="inner-box">

                                <div className='btn-layout' data-btn-num="1">
                                    <button 
                                        className="btn" 
                                        data-btn-type="fill-main" 
                                        data-btn-size="lg" 
                                        onClick={()=>handleComplete()}
                                        disabled={!systolic || !diastolic || !recordDate || !recordTime}
                                    >
                                        <span>완료</span>
                                    </button>
                                </div>

                            </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}
                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            opacity="90"
                        />
                    )}

                </div>
            </div>


            <Modal isOpen={modalOpen} setIsOpen={setModalOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>오늘 날짜보다 미래 날짜를 선택할 수 없습니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={closeModal}>
                                <span>확인</span>
                            </button>
                            
                        </div>
                    </div>
                </div>
            </Modal> 

            <Modal isOpen={modalTimeOpen} setIsOpen={setModalTimeOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>현재 시간보다 미래 시간을 선택할 수 없습니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={closeModalTime}>
                                <span>확인</span>
                            </button>
                            
                        </div>
                    </div>
                </div>
            </Modal> 


        </>
    );
};

export default BloodPressureWrite;
